import React, { Component } from "react";
import "../../assets/bootstrap/css/bootstrap.min.css";
import "../../assets/fonts/font-awesome.min.css";
import "../../assets/css/styles.css";
import axios from "axios";
import $ from "jquery";

export class TriageSidebar extends Component {
  constructor(props) {
    super(props);

   

    // const url = 'hghobs.keshonect.co.ke'

    this.state = {
      module: "",
      profession: "",
      name: "",
      nationality: "",
      age: "",
    };

    // this.handleChange = this.handleChange.bind(this);
    // this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    console.log(localStorage.getItem("accessToken"));
    console.log(localStorage.getItem("currentVisitId"));
    console.log(localStorage.getItem("currentVisitName"));
    console.log(localStorage.getItem("currentVisitNationality"));
    console.log(localStorage.getItem("currentVisitProfession"));
    console.log(localStorage.getItem("currentVisitAge"));
    this.setState({
      age: localStorage.getItem("currentVisitAge"),
      name: localStorage.getItem("currentVisitName"),
      nationality: localStorage.getItem("currentVisitNationality"),
      profession: localStorage.getItem("currentVisitProfession"),
    });

    $(".Dashboard-class").click(function (e) {
      // e.PreventDefault()
      // localStorage.removeItem('currentVisitId')
      // localStorage.removeItem('currentVisitName')
      // localStorage.removeItem('currentVisitNationality')
      // localStorage.removeItem('currentVisitProfession')
      // localStorage.removeItem('currentVisitAge')
      setTimeout(function () {
        window.location.href = "/triage/init/dashboard";
      }, 500);
    });

    if (localStorage.getItem("currentVisitName")) {
      $(".patientDetails").show();
    }
    $(".close").on("click", function () {
      $(".modal").hide();
    });
    if (localStorage.getItem("accessToken") == null) {
      $("#loginFirst").show();
      // window.location.href = '/'
    }
  }
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { profession, name, nationality, age } = this.state;
    return (
      <div className="pb-5">
        <div className="sidebar-container pb-5">
          {/* <div className="sidebar-logo">
						Project Name
					</div> */}
          <ul className="sidebar-navigation">
            <li className="header patientDetails" style={displayHidden}>
              <h4>Patient Details</h4>
              <br />
              <b> Name: </b>
              {name}
              <br />
              <b>Nationality: </b>
              {nationality}
              <br />
              <b>Age: </b>
              {age}
              <br />
              <b>Profession: </b>
              {profession}
              <input type="hidden" value={name} className="patientName" />
            </li>
            <li>
              <a className="Dashboard-class">
                <i className="fa fa-plus-square" aria-hidden="true"></i>Doctor`s
                Dashboard
              </a>
            </li>
            <li>
              <a href="/doctor/general/observation">
                <i className="fa fa-plus-square" aria-hidden="true"></i>General
                Observations
              </a>
            </li>

            <li>
              <a href="/chief/complaint">
                <i className="fa fa-plus-square" aria-hidden="true"></i> Chief
                Complaint
              </a>
            </li>
            <li>
              <a href="/menstrual/history">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Menstrual History
              </a>
            </li>

            <li>
              <a href="/previous/obstetrics/history">
                <i className="fa fa-plus-square" aria-hidden="true"></i>Previous
                Obstetrics History
              </a>
            </li>
            <li>
              <a href="/antenatal/history">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Antenatal History
              </a>
            </li>
            <li>
              <a href="/ob/sound">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Obstetrics Ultrasound
              </a>
            </li>

            <li>
              <a href="/preplan/analysis">
                <i className="fa fa-plus-square" aria-hidden="true"></i>Preplan
                Analysis Executed
              </a>
            </li>

            <li>
              <a href="/previous/pregnancy/complication">
                <i className="fa fa-plus-square" aria-hidden="true"></i>Previous
                Pregnancy Complication
              </a>
            </li>
            <li>
              <a href="/utilization/of/drugs">
                <i className="fa fa-plus-square" aria-hidden="true"></i>
                Utilization Of Drugs
              </a>
            </li>

            <li>
              <a href="/sexual/history">
                <i className="fa fa-plus-square" aria-hidden="true"></i>Sexual
                History
              </a>
            </li>

            <li>
              <a href="/prior/ob/or/gyn/infections">
                <i className="fa fa-plus-square" aria-hidden="true"></i>Prior Ob
                or Gyn Infections
              </a>
            </li>

            <li>
              <a href="/medical/disorders">
                <i className="fa fa-plus-square" aria-hidden="true"></i>Medical
                Disorders
              </a>
            </li>

            <li>
              <a href="/previous/abdominal">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Previous gynecological or abdominal surgery disorders
              </a>
            </li>
          {localStorage.getItem('currentModule') == 'triage' ?  <li>
              <a href="/triage/admission/triage">
                <i className="fa fa-plus-square" aria-hidden="true"></i>
                Admission Query
              </a>
            </li>: 
            <li></li>
            }
           
            <li>
              <a href="/physical/examination">
                <i className="fa fa-plus-square" aria-hidden="true"></i>Physical
                Examination General
              </a>
            </li>

            <li>
              <a href="/physical/examination/inspection">
                <i className="fa fa-plus-square" aria-hidden="true"></i>Physical
                Examination Inspection
              </a>
            </li>
            <li>
              <a href="/physical/examination/pelvic">
                <i className="fa fa-plus-square" aria-hidden="true"></i>Physical
                Examination Pelvic
              </a>
            </li>
            <li>
              <a href="/physical/examination/induction">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Physical Examination Induction
              </a>
            </li>

            <li>
              <a href="/tests/to/be/done">
                <i className="fa fa-plus-square" aria-hidden="true"></i> Tests
                To Be Done In the Lab
              </a>
            </li>
            <li>
              <a href="/external/lab/tests">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                External Lab Tests
              </a>
            </li>
            <li>
              <a href="/triage/treatment">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Treatment
              </a>
            </li>
            <li>
              <a href="/diagnosis/study">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Diagnosis and Plan
              </a>
            </li>
            <li>
              <a href="/triage/all/data">
                <i className="fa fa-plus-square" aria-hidden="true"></i>All Data
              </a>
            </li>
            <li>
              <a href="/send/to/module">
                <i className="fa fa-plus-square" aria-hidden="true"></i> Send To
                Module
              </a>
            </li>

            <li>
              <a href="/discharge/form">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Discharge Patient
              </a>
            </li>

            <li className="header"></li>
          </ul>
        </div>
      </div>
    );
  }
}

export default TriageSidebar;
